import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
  UncontrolledTooltip,
} from "reactstrap"

import * as OrderService from "../../services/orders/calls"

import "react-perfect-scrollbar/dist/css/styles.css"

import Breadcrumbs from "../../components/Common/Breadcrumb2"
import SimpleBar from "simplebar-react"

//i18n
import { formatDate, formatPhoneNumber, getOrderLastStatus } from "helpers"
import moment from "moment"
import { withTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

import TimeLine from "components/TimeLine"
import { Navigation, Pagination, Scrollbar } from "swiper"
import "../../../node_modules/swiper/swiper.scss"

import classnames from "classnames"
import DataList from "components/DataList"
import { getDigitalAr } from "services/shipping-events/calls"

import { getRequestsAR } from "services/support/calls"

import { faCircleNotch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import toast from "components/Toast/Toast"
import { getIcon, getLocalName } from "./constants"

const Detalhes = props => {
  //meta title
  document.title = "Detalhes | Sensetek"
  moment.locale("pt-br")

  const openInNewTab = url => {
    let win = window.open()
    win.document.write(
      '<iframe src="' +
        url +
        '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
    )
  }

  let { id } = useParams()
  const [hasError, setError] = useState(false)
  const [order, setOrder] = useState(null)
  const firstAddress =
    order?.addresses?.length > 0
      ? `${order?.addresses[0]?.street}, ${
          order?.addresses[0]?.streetNumber || ""
        }, ${order?.addresses[0]?.addressComplement || ""} - ${
          order?.addresses[0]?.neighborhood
        } - ${order?.addresses[0]?.city}, ${order?.addresses[0]?.state} - ${
          order?.addresses[0]?.postcode
        }`
      : ""
  const currentAddress = order?.currentAddress
    ? `${order?.currentAddress?.street}, ${
        order?.currentAddress?.streetNumber || ""
      }, ${order?.currentAddress?.addressComplement || ""} - ${
        order?.currentAddress?.neighborhood
      } - ${order?.currentAddress?.city}, ${order?.currentAddress?.state} - ${
        order?.currentAddress?.postcode
      }`
    : ""
  const [statuses, setStatuses] = useState([])
  const [isLoading, handleLoading] = useState(false)
  const [activeTab, handleActiveTab] = useState("1")
  const [activeVerticalTab, handleActiveVerticalTab] = useState("1")
  const [timeLine, setTimeLine] = useState([])
  const [timeLineCards, setTimeLineCards] = useState(0)
  const [requests, setRequests] = useState([])
  const [closedRequestAnnotations, setClosedRequestAnnotations] = useState(null)

  const [arDigitalLoading, setArDigitalLoading] = useState(false)

  const portador =
    order?.orderDetails?.length > 0
      ? order?.orderDetails?.map((od, idx) => ({
          id: idx,
          name: od.clientName,
          document: od?.clientDocumentId,
          telefone: od.clientPhone,
        }))
      : []

  const timeLineBuilder = (order, statuses) => {
    let list = []
    let lastPlaceInOrder = 1
    if (order?.status.length === 0) {
      statuses.forEach((el, idx) => {
        list.push({
          title: el.name,
          icon: getIcon(-1),
          active: idx == statuses.length - 1 ? true : false,
          subclass: "text-muted",
        })
      })
      setTimeLine(list)
      setTimeLineCards(list.length < 12 ? list.length : 12)
      return
    }
    _.sortBy(order?.status || [], ["occurredAt"])
      .filter(s => !s.shippingEvent?.deletedAt)
      .forEach((el, idx) => {
        if (el.statusId) {
          lastPlaceInOrder =
            el.status.placeInOrder == null
              ? lastPlaceInOrder
              : el.status.placeInOrder > lastPlaceInOrder
              ? el.status.placeInOrder
              : lastPlaceInOrder
          list.push({
            title: el.status.name,
            description:
              idx != -1 ? formatDate(el.occurredAt, "DD/MM/YYYY") : " ",
            icon: getIcon(el.statusId),
            active: idx == order?.status.length - 1 ? true : false,
            subclass: el.occurredAt ? "text-primary" : "text-muted",
          })
          if (!el.status.isLast && idx == order?.status.length - 1) {
            statuses.map(status => {
              if (status.placeInOrder > lastPlaceInOrder) {
                list.push({
                  title: status.name,
                  icon: getIcon(status.id),
                  subclass: "text-muted",
                })
              }
            })
          }
        } else {
          list.push({
            title: el.externalEventName,
            description:
              idx != -1 ? formatDate(el.occurredAt, "DD/MM/YYYY") : " ",
            icon: getIcon(el.statusId),
            active: false,
            subclass: "text-muted",
          })
        }
      })
    setTimeLine(list)
    setTimeLineCards(list.length < 12 ? list.length : 12)
    return
  }

  const fetchOrder = async () => {
    setError(false)
    try {
      const res = await OrderService.find(id)
      const { order, statuses } = res.payload
      timeLineBuilder(order, statuses)
      setOrder(order)
      setStatuses(statuses)
      latest(order)
    } catch (err) {
      setError(err)
    } finally {
      handleLoading(false)
    }
  }

  const toggleTab = tabId => {
    handleActiveTab(`${tabId}`)
  }

  const fetchArDigital = async () => {
    setArDigitalLoading(true)
    try {
      const base64 = await getDigitalAr(order?.id)
      let win = window.open()
      win.document.write(
        `<iframe src="${base64}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`
      )
    } catch (error) {
      console.error(error)
      toast("warning", "AR digital não se encontra disponível.", "")
    } finally {
      setArDigitalLoading(false)
    }
  }

  const latest = async order => {
    try {
      const { payload } = await getRequestsAR(order.id)
      setRequests(payload.supports)
      if (payload.supports?.closed?.length > 0) {
        const lastIsAuto =
          payload.supports?.closed
            .filter(c => c.currentQueueType.isAuto)
            .slice(-1)[0] || null
        const lastIsFraude =
          payload.supports?.closed
            .filter(c => c.currentQueueType?.name.toLowerCase() === "fraude")
            .slice(-1)[0] || null
        const isFraude =
          payload.supports?.opened
            .filter(c => c.currentQueueType?.name.toLowerCase() === "fraude")
            .slice(-1)[0] || null
        const dates = [lastIsAuto, lastIsFraude, isFraude]
          .sort((a, b) => {
            return moment(b?.createdAt, "YYYY-MM-DD HH:mm:ss").diff(
              a?.createdAt,
              "YYYY-MM-DD HH:mm:ss"
            )
          })
          .filter(a => a !== null)
        if (dates.length > 0) {
          const end = dates[0].annotations
          setClosedRequestAnnotations(end ? JSON.parse(end) : null)
        } else {
          setClosedRequestAnnotations(null)
        }
      } else {
        const isFraude =
          payload.supports?.opened
            .filter(c => c.currentQueueType?.name.toLowerCase() === "fraude")
            .slice(-1)[0] || null
        if (isFraude) {
          setClosedRequestAnnotations(
            isFraude ? JSON.parse(isFraude?.annotations) : null
          )
        } else {
          setClosedRequestAnnotations(null)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    handleLoading(true)
    fetchOrder()
  }, [])

  const getArToShow = order => {
    const transp = order?.shippingCompany?.name?.toLowerCase()
    if (transp == "flash") {
      return order?.shippingTrackerCode
        ? order?.shippingTrackerCode
        : order?.shippingOrderCode
    }
    if (transp == "mobi") {
      return order?.shippingOrderCode
    }
    return order?.shippingTrackerCode
      ? order?.shippingTrackerCode
      : order?.shippingOrderCode
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t(`Pedido #${getArToShow(order)}`)}
            breadcrumbItems={[
              { title: props.t("Rastreio") },
              { title: props.t("Detalhes") },
            ]}
          />
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  Linha do Tempo
                </CardHeader>
                <CardBody>
                  {/* <CardTitle className="mb-4">Linha do Tempo</CardTitle> */}
                  <TimeLine
                    slidesperview={timeLineCards}
                    // navigation={true}
                    loop={false}
                    pagination={{
                      clickable: true,
                    }}
                    scrollbar={{ draggable: true }}
                    modules={[Pagination, Navigation, Scrollbar]}
                    className="owl-carousel owl-theme  navs-carousel events"
                    children={timeLine}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <Nav tabs className="nav-tabs-custom nav-justified">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={activeTab === "1" ? "active" : ""}
                        onClick={() => {
                          toggleTab("1")
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-user"></i>
                        </span>
                        <span className="d-none d-sm-block">Detalhes</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={activeTab === "2" ? "active" : ""}
                        onClick={() => {
                          toggleTab("2")
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-user"></i>
                        </span>
                        <span className="d-none d-sm-block">
                          Eventos do Objeto
                        </span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={activeTab === "3" ? "active" : ""}
                        onClick={() => {
                          toggleTab("3")
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-home"></i>
                        </span>
                        <span className="d-none d-sm-block">Informações</span>
                      </NavLink>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={activeTab === "4" ? "active" : ""}
                        onClick={() => {
                          toggleTab("4")
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-user"></i>
                        </span>
                        <span className="d-none d-sm-block">Mensagens</span>
                      </NavLink>
                    </NavItem> */}
                  </Nav>

                  <TabContent activeTab={activeTab} className="p-3 text-muted">
                    <TabPane tabId="1">
                      <DataList
                        infos={[
                          {
                            label: "Data Criação",
                            value: formatDate(
                              order?.emittedAt ||
                                order?.orderedAt ||
                                order?.createdAt,
                              "DD/MM/YYYY"
                            ),
                          },
                          {
                            label: "AR Transportadora",
                            value: getArToShow(order),
                          },
                          {
                            label: "Status Atual",
                            value: getOrderLastStatus(order),
                          },
                          {
                            label: "Recebedor",
                            value: order?.shippingReceiver || " - ",
                          },
                          {
                            label: "Documento Recebedor",
                            value: order?.shippingReceiverDocumentId || " - ",
                          },
                          {
                            label: "Grau Paretensco",
                            value: order?.shippingGrauParentesco || " - ",
                          },
                          {
                            label: "Data Última consulta na transportadora",
                            value: moment(order?.updatedAt).format(
                              "DD/MM/YYYY HH:mm"
                            ),
                          },
                          {
                            label: "Endereço Original",
                            value: firstAddress,
                          },
                          {
                            label: "Endereço Atual",
                            value: currentAddress,
                          },
                        ]}
                      />
                    </TabPane>
                    <TabPane tabId="2">
                      <Card>
                        <CardBody>
                          <div className="table-responsive">
                            <Table className="table mb-0">
                              <thead className="table-secondary">
                                <tr>
                                  <th>Data</th>
                                  <th>Título</th>
                                  <th>Descrição</th>
                                  <th>Detalhes</th>
                                </tr>
                              </thead>
                              <tbody>
                                {_.sortBy(order?.status || [], ["occurredAt"])
                                  .reverse()
                                  .filter(s => !s.shippingEvent?.deletedAt)
                                  .map(
                                    (
                                      {
                                        status,
                                        externalEventName,
                                        externalEventId,
                                        shippingLocal,
                                        occurredAt,
                                        rawInfo,
                                      },
                                      index
                                    ) => (
                                      <tr key={index}>
                                        <td>
                                          {moment(occurredAt).format(
                                            "DD/MM/YYYY HH:mm"
                                          )}
                                        </td>
                                        <td>{status?.name}</td>
                                        <td>
                                          {externalEventName || status?.name}
                                        </td>

                                        <td>
                                          {status?.name == "Entregue" ? (
                                            <ul className="list-unstyled mb-0">
                                              <li
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                              >
                                                <a
                                                  target="_blank"
                                                  className={`btn btn-sm btn-primary`}
                                                  onClick={async () => {
                                                    fetchArDigital()
                                                  }}
                                                >
                                                  {arDigitalLoading ? (
                                                    <FontAwesomeIcon
                                                      icon={faCircleNotch}
                                                      spin
                                                      size="1x"
                                                      color="#000"
                                                    />
                                                  ) : (
                                                    <>
                                                      <i
                                                        className="mdi mdi-file-document-edit-outline"
                                                        id={`arDigital-${index}`}
                                                      ></i>
                                                      <UncontrolledTooltip
                                                        placement="top"
                                                        target={`arDigital-${index}`}
                                                      >
                                                        Recuperar Ar Digital
                                                      </UncontrolledTooltip>
                                                    </>
                                                  )}
                                                </a>
                                              </li>
                                            </ul>
                                          ) : (
                                            getLocalName(
                                              rawInfo,
                                              status,
                                              shippingLocal,
                                              order,
                                              externalEventId
                                            )
                                          )}
                                        </td>
                                      </tr>
                                    )
                                  )}
                              </tbody>
                            </Table>
                          </div>
                        </CardBody>
                      </Card>
                    </TabPane>
                    <TabPane tabId="3">
                      <Row>
                        <Col sm={2}>
                          <Nav pills className="flex-column">
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  "mb-2": true,
                                  active: activeVerticalTab === "1",
                                })}
                                onClick={() => {
                                  handleActiveVerticalTab("1")
                                }}
                              >
                                Pedido
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  "mb-2": true,
                                  active: activeVerticalTab === "3",
                                })}
                                onClick={() => {
                                  handleActiveVerticalTab("3")
                                }}
                              >
                                Transporte
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: activeVerticalTab === "4",
                                })}
                                onClick={() => {
                                  handleActiveVerticalTab("4")
                                }}
                              >
                                Cliente
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </Col>
                        <Col md="10">
                          <TabContent
                            activeTab={activeVerticalTab}
                            className="text-muted mt-4 mt-md-0"
                          >
                            <TabPane tabId="1">
                              <DataList
                                infos={[
                                  {
                                    label: "Fábrica",
                                    value: order?.factory.name,
                                  },
                                  {
                                    label: "Tipo de emissão",
                                    value: order?.emissionType.name,
                                  },
                                  {
                                    label: "Data do pedido",
                                    value: moment(order?.orderedWebAt).format(
                                      "DD/MM/YYYY"
                                    ),
                                  },
                                  /*}
                                  {
                                    label: "Remissão cartão",
                                    value: order?.remissionCard == true ? 'Sim' : 'Não',
                                  },
                                  */
                                  {
                                    label: "Cartão design",
                                    value: order?.cardDesign,
                                  },
                                  {
                                    label: "Package design",
                                    value: order?.packageDesign,
                                  },
                                  {
                                    label: "Nome arquivo",
                                    value: order?.fileName,
                                  },
                                ]}
                              />
                            </TabPane>
                            <TabPane tabId="3">
                              <DataList
                                infos={[
                                  {
                                    label: "Empresa de entrega",
                                    value: order?.shippingCompany.name,
                                  },
                                  {
                                    /* { label: 'Agencia de expedição', value: order.shippingPostAgency } */
                                  },
                                  {
                                    label: "AR Courier",
                                    value: order?.shippingOrderCode,
                                  },
                                  {
                                    label: "Previsão de entrega",
                                    value: order?.expectedDeliveryAt
                                      ? moment(
                                          order?.expectedDeliveryAt,
                                          "YYYY-MM-DD"
                                        ).format("DD/MM/YYYY")
                                      : "Sem previsão",
                                  },
                                  {
                                    label: "Entregue em",
                                    value: order?.shippingDeliveryAt
                                      ? moment(
                                          order?.shippingDeliveryAt
                                        ).format("DD/MM/YYYY HH:mm")
                                      : "Ainda não entregue",
                                  },
                                ]}
                              />
                            </TabPane>

                            <TabPane tabId="4">
                              <SimpleBar
                                style={{
                                  maxHeight: "300px",
                                  overflowX: "hidden",
                                }}
                              >
                                <Table
                                  striped
                                  bordered
                                  hover
                                  size="sm"
                                  responsive
                                >
                                  <thead>
                                    <tr>
                                      <th>Nome Empresa</th>
                                      <th>Nome Cliente</th>
                                      <th>Telefone</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {portador.map(col => (
                                      <tr key={col.id}>
                                        <td>{col.name}</td>
                                        <td>{col.document}</td>
                                        <td>
                                          {formatPhoneNumber(col.telefone)}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </SimpleBar>
                            </TabPane>
                          </TabContent>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Detalhes.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Detalhes)
